export interface Essay {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  date: string; // ISO
  dateDisplay: string;
  dateModified?: string; // ISO
  dateModifiedDisplay?: string;
  readingMinutes: number;
  summary?: string; // Short "In short:" opener for AI-search citation
  ogImage?: string; // Absolute URL to custom OG image; falls back to site default
}

export const essays: Essay[] = [
  {
    slug: "the-second-loop",
    title: "The Second Loop",
    subtitle:
      "What the token capital era gets right, what it cannot see, and the asset no one can extract",
    author: "Kent H. Frazier",
    date: "2026-06-10",
    dateDisplay: "June 10, 2026",
    dateModified: "2026-07-10",
    dateModifiedDisplay: "July 10, 2026",
    readingMinutes: 8,
    summary:
      "AI's 'token capital' loop compounds what your people already knew. But the scarce asset — human judgment, taste, and trust — needs its own loop. Organizations that thrive will run both: extraction alongside development.",
  },
  {
    slug: "the-space-between",
    title: "The Space Between",
    subtitle: "What grows trust",
    author: "Kent H. Frazier",
    date: "2026-07-14",
    dateDisplay: "July 14, 2026",
    readingMinutes: 5,
    ogImage: "https://www.paradoxedge.com/og-the-space-between.png?v=1",
    summary:
      "Trust built on role, title, and delivery is brittle — it snaps under pressure. Trust built between two people who have actually met each other holds. This essay is about the space between: what Buber called the between, what grows there, and why it is the developmental ground of being fully human at work.",
  },
];

export const getEssay = (slug: string) => essays.find((e) => e.slug === slug);